import { render, staticRenderFns } from "./language-select.vue?vue&type=template&id=7fbb84c8&scoped=true&"
import script from "./language-select.ts?vue&type=script&lang=ts&"
export * from "./language-select.ts?vue&type=script&lang=ts&"
import style0 from "./language-select.scss?vue&type=style&index=0&id=7fbb84c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbb84c8",
  null
  
)

component.options.__file = "language-select.vue"
export default component.exports